import Game from "../../../../../src/Game";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import PointManager from "./PointManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager";
import AngleBgManager from "./AngleBgManager";
import PointTagManager from "./PointTagManager";
import Circle from "../../../../../src/entities/Circle";
import SliderManager from "./SliderManager";
import CircleAnimationManager from "./CircleAnimationManager/CircleAnimationManager";

import InfoSlider from "../../../../../src/entities/InfoSlider/InfoSlider";
import CalculationLine from "../entities/CalculationLine";
import GuideText from "../../../../../src/entities/GuideText";
import SegmentChord from "../entities/SegmentChord";

import { CIRCLE_RADIUS, CENTER_OF_CIRCLE, INFO_SLIDER_COORD, ARC_COLOR_ARR } from "../types/Config";
import isCircumPointBetween from "../../../../../src/utils/isCircumPointBetween";

import generatePoints from "../../../../../src/utils/generator/generatePoints";
import { getCircleRadians } from "../helpers/getCircleRadians";
import isPortail from "../../../../../src/utils/isPortial";


export default class ComponentManager {
  static instance: ComponentManager;
  Game = Game.getInstance();
  cRadius = CIRCLE_RADIUS;
  cCoord = isPortail(this.Game.getDim(), CENTER_OF_CIRCLE);

  PointManager = new PointManager(this.cCoord);
  AngleBgManager = new AngleBgManager(this.cCoord, this.PointManager.getRadians()[0]);
  LineManager = new LineManager();
  AngleManager = new AngleManager();
  PointTagManager = new PointTagManager();
  SliderManager = new SliderManager();
  infoSlider = new InfoSlider(INFO_SLIDER_COORD);
  calcLine = new CalculationLine();
  CircleAnimationManager: CircleAnimationManager;
  SegmentChord = new SegmentChord(this.cCoord);
  GuideText = new GuideText({ x: 100, y: 10 });
  circle: Circle;
  
  constructor() {
    if (!ComponentManager.instance) {
      ComponentManager.instance = this;
    }

    const radians = this.PointManager.getRadians();
    this.circle = new Circle(this.cCoord, radians, ARC_COLOR_ARR);
    this.CircleAnimationManager = new CircleAnimationManager(this.PointManager, this.AngleManager, this.AngleBgManager, this.LineManager, this.circle);

    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.drawElements());
    rootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());

    this.drawElements();
  }
  static getInstance = () => ComponentManager.instance;
  generatePointTagPoints = () => generatePoints(this.cCoord, this.PointManager.getRadians(), this.cRadius + 34);

  drawElements() {
    const points = this.PointManager.getPoints();
    const radians = this.PointManager.getRadians();
    const isbtw = isCircumPointBetween(this.cCoord, points[3], radians[0], radians[1]);

    this.PointManager.draw();
    this.circle.draw({ radians: getCircleRadians(radians, isbtw), radius: this.cRadius });
    this.LineManager.draw(points);
    this.AngleManager.draw(points, isbtw);
    this.SegmentChord.draw(CIRCLE_RADIUS, [radians[0], radians[1]], [points[1], points[2]], isbtw);
    this.PointTagManager.updateCenterName(points, isbtw);
    this.PointTagManager.updateCoord(this.generatePointTagPoints());
  }
}

